import APIClient from '@/shared/http/clients/api'

const resourceName = 'APRTemplate'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const ImporAPR = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ImportableByAPR`, data, config)
const GetAPRTemplateGrid = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAPRTemplateGrid?limit=${limit}&index=${index}`, data, config)
const GetAPRTemplatePainelById = (aprId, revisao, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAPRTemplatePainelById/${aprId}/${revisao}`, data, config)
const GetEdicaoAPRTemplateDetalhesRiscoCausaById = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetEdicaoAPRTemplateDetalhesRiscoCausaById`, data, config)
const GetAPRTemplateDetalhesRiscoCausaById = (aprId, revisao, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAPRTemplateDetalhesRiscoCausaById/${aprId}/${revisao}`, data, config)
const GetProbabilidadeSeveridadeMatrizByAPRTemplate = (aprId, revisao, riscoId, causaId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetProbabilidadeSeveridadeMatrizByAPRTemplate/${aprId}/${revisao}/${riscoId}/${causaId}`, data, config)
const EdicaoAddAPRTemplate = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/EdicaoAddAPRTemplate`, data, config)
const aprTemplateAgAprovacao = (aprId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/aprTemplateAgAprovacao/${aprId}`, data, config)
const aprTemplateReprovado = (aprId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/aprTemplateReprovado/${aprId}`, data, config)
const CriarNovoTemplateWeb = (descricaoId, atividadeId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/CriarNovoTemplateWeb/${descricaoId}/${atividadeId}`, data, config)
const AprovacaoTemplateByApr = (aprTemplateId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/AprovacaoTemplateByApr/${aprTemplateId}`, data, config)
const ReprovaTemplateByApr = (aprTemplateId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/ReprovaTemplateByApr/${aprTemplateId}`, data, config)
const ClonarTemplateWeb = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/CloningByTemplate`, data, config)
const EditarTemplateWeb = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/EditTemplateByTemplateId`, data, config)
const DeleteTemplateApr = (templateId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DeleteTemplateApr/${templateId}`, data, config)
const DefinirResponsaveisTemplateApr = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DefinirResponsaveisTemplateApr`, data, config)

const ApruserRepository = {
  ImporAPR,
  DeleteTemplateApr,
  AprovacaoTemplateByApr,
  ReprovaTemplateByApr,
  GetAPRTemplateGrid,
  GetEdicaoAPRTemplateDetalhesRiscoCausaById,
  GetAPRTemplatePainelById,
  GetAPRTemplateDetalhesRiscoCausaById,
  ClonarTemplateWeb,
  GetProbabilidadeSeveridadeMatrizByAPRTemplate,
  EdicaoAddAPRTemplate,
  aprTemplateAgAprovacao,
  aprTemplateReprovado,
  CriarNovoTemplateWeb,
  EditarTemplateWeb,
  DefinirResponsaveisTemplateApr
}

export default ApruserRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprTemplate.js